import * as React from 'react';
import Button from '@mui/material/Button';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterDrawer from './FilterDrawer';
import { useLayoutEffect, useMemo } from 'react';
import {
  pickerValuesMap,
  pickerVariants,
  setDateRangeInUrl,
} from '../../DatePickers/DateRangeFilter';
import Badge from '@mui/material/Badge';
import { useFiltersUrlState, getFilterParams } from './useFiltersUrlState';

const FilterOverview = () => {
  const { filters, setFilters, setParams } = useFiltersUrlState();

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // setDefault date state if it doesn't exist
  useLayoutEffect(() => {
    const params = getFilterParams();
    if (!params.end_dt && !params.start_dt) {
      setDateRangeInUrl(pickerValuesMap.last7Days, pickerVariants, setParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtersLength = useMemo(
    () =>
      Object.values(filters).reduce((acc, filterValue) => {
        // for array
        if (Array.isArray(filterValue) && filterValue.length) {
          acc += 1;
        }
        // for object
        else if (Object.keys(filterValue).length) {
          acc += 1;
        }

        return acc;
      }, 0),
    [filters]
  );

  return (
    <div>
      <Badge
        badgeContent={`${filtersLength}`}
        invisible={!filtersLength}
        color="primary"
      >
        <Button
          onClick={toggleDrawer(true)}
          variant="outlined"
          endIcon={<FilterListIcon />}
          sx={{
            color: '#000',
            border: '1px solid #E1E1E1',
            fontSize: '16px',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
              borderColor: 'darkgray',
            },
          }}
        >
          Filter
        </Button>
      </Badge>
      <FilterDrawer
        open={open}
        onClose={() => setOpen(false)}
        filters={filters}
        setFilters={setFilters}
        setParams={setParams}
      />
    </div>
  );
};
export default FilterOverview;
